<template>
    <div class="main">
        <div class="topNav">
            <!-- <img class="logo" src="/static/images/utils/logos.png" /> -->
            <span class="logoTxt">{{ sysName }}</span>
        </div>

        <div class="loginBox">
            <div class="top"></div>
            <div class="loginForm">
                <div class="loginTit">用户登录</div>
                <el-form ref="form" :model="loginForm" label-width="40px">
                    <el-form-item :label="$t('login.account')">
                        <el-input class="logInt" v-model="loginForm.userAccount" :placeholder="$t('login.account')" size="big" type="text"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('login.password')">
                        <el-input class="logInt" v-model="loginForm.password" :placeholder="$t('login.password')" size="big" type="password" show-password @keyup.enter.native="login()"></el-input>
                    </el-form-item>
                </el-form>
                <el-button @click="login" type="primary" class="loginBtn">{{$t('login.btn')}}</el-button>
                <div class="botBtnNav">
                    <el-button type="text" @click="toRegOrg">注册主体</el-button>
                </div>
            </div>
            <div class="clear0"></div>
        </div>
        <div class="copyRights">
            <!-- <div>主办：农业农村厅</div> -->
            <div></div>
            <div></div>
        </div>

        <el-dialog :title="centerDialogTit" width="660px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" :visible.sync="centerDialogVisible" v-if="centerDialogVisible" append-to-body>
            <component :is="centerComp.con" :key="centerComp.ts" :param="centerComp.param" @closeCallback="centerDialogVisible=false" @confirmCallback="centerConfirmCallback"></component>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "login",
    data () {
        return {
            sysName: '农产品质量追溯管理平台',
            loginForm: {
                userAccount: 'admin',
                password: '123456',
            },
            utArr: [],

            centerDialogTit: '',
            centerDialogVisible: false,
            centerComp: {},
        };
    },
    methods: {
        login: function () {
            let _this = this;
            this.req('/common/web_login', this.loginForm, function (data) {
                if (data.success) {
                    _this.initUserData(data.obj);
                } else {
                    _this.$message.error(data.message);
                }
            })
        },
        initUserData: function (data) {
            let _this = this;
            sessionStorage.setItem("uid", data.id);
            sessionStorage.setItem("type", data.type);
            sessionStorage.setItem("userName", data.userName);
            sessionStorage.setItem("avatar", data.avatar ? data.avatar : '');

            this.$router.push("/");
        },
        resize: function () {
            let h = document.body.clientHeight;
            let mt = (h - 550) / 2 - 30;
            if (mt < 0) {
                mt = 0;
            }
            this.mt = mt;
        },
        ckNewVersion: function () {
            this.req('/common/qry_web_version', {}, function (data) {
                if (data.success) {
                    let newVersion = data.obj;
                    let locVersion = localStorage.getItem('qnbVersion');
                    localStorage.setItem('qnbVersion', newVersion);

                    if (newVersion != locVersion) {
                        window.location.reload(true);
                    }
                }
            }, 'get')
        },
        toRegOrg: function () {
            this.centerComp = {
                con: () => import('@/components/mar/ncp/ncp_org_edit.vue'),
                ts: new Date().getTime(),
                param: {
                    id: null,
                },
            };
            this.centerDialogTit = '注册主体';
            this.centerDialogVisible = true;
        },
        centerConfirmCallback: function () {
            this.centerDialogVisible = false;
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            console.log("mounted login -- >");
            let _this = this;
            // this.ckNewVersion();
            this.utArr = this.consts.userType;

            this.resize();
            window.addEventListener('resize', () => {
                _this.resize();
            });

        });
    }
};
</script>

<style scoped>
.main {
    height: 100%;
}
.topNav {
    height: 94px;
    line-height: 94px;
    background-image: linear-gradient(to right, #00a272, #00a272);
    text-align: center;
    position: relative;
}
.logo {
    display: inline;
    height: 50px;
    vertical-align: middle;
    margin-top: -14px;
    font-size: 0;
}
.logoTxt {
    color: #fff;
    font-size: 32px;
    font-weight: 400px;
    padding-left: 5px;
}
.mt1 {
    height: 20%;
}
.mainTit {
    font-size: 48px;
    margin-bottom: 10px;
    /* font-weight: 300; */
    font-weight: 400;
}
.copyRights {
    padding-top: 50px;
    font-size: 14px;
    font-weight: 300;
    color: #717074;
    text-align: center;
}
.mt1 {
    height: 15%;
}

.loginBox {
    width: 900px;
    margin: auto;
    margin-top: calc(50vh - 300px);
}

.top {
    width: 500px;
    height: 350px;
    background-image: url("/static/images/pic/loginbg1.png");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;

    /* background-color: #00A272; */
    /* background-image: linear-gradient(to bottom, rgba(101,16,173,0.8), rgba(101,16,173,0.5),  rgba(255,255,255,1)); */
    text-align: center;
    /* color: #00A272; */
    overflow: hidden;
    float: left;
}

.loginForm {
    width: 350px;
    float: right;
    padding-top: 60px;
}

.loginBtn {
    width: 100%;
    box-sizing: border-box;
    border-radius: 20px;
    margin-top: 20px;
}

.logInt >>> input:-internal-autofill-selected {
    transition: background-color 5000s ease-in-out 0s;
    background-color: rgba(255, 255, 255, 0) !important;
}

.logInt >>> input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
    background-color: rgba(255, 255, 255, 0) !important;
}

.logInt >>> input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s;
    background-color: rgba(255, 255, 255, 0) !important;
}

.crLink {
    text-decoration: none;
    color: #00a272;
    padding-left: 10px;
}

.loginTit {
    font-size: 22px;
    font-weight: 400;
    text-align: center;
    padding-bottom: 20px;
}

.botBtnNav {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue